import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { AccountSettingsPopup } from 'ui/components';
import ModalLogout from 'ui/components/Modals/Logout';

import { ClickOutside } from '..';
import { CircleFrame, CircleImage, ProfilePicContainer } from './style';

const ProfilePic = ({ src }) => {
  const [showAccountSettingsPopup, setShowAccountSettingsPopup] = useState(
    false
  );

  return (
    <ClickOutside callback={() => setShowAccountSettingsPopup(false)}>
      <ProfilePicContainer id="profile-pic-container">
        <CircleFrame
          onClick={() => setShowAccountSettingsPopup(!showAccountSettingsPopup)}
        >
          <CircleImage src={src} />
        </CircleFrame>
        {showAccountSettingsPopup && (
          <AccountSettingsPopup
            handleClose={() => setShowAccountSettingsPopup(false)}
          />
        )}
        <ModalLogout />
      </ProfilePicContainer>
    </ClickOutside>
  );
};

ProfilePic.propTypes = {
  src: PropTypes.string
};

export default ProfilePic;
